//记得在 src\components\lang\zhLoad.js 里面添加对象
const outPlantIntervalTimeNextSign = {

};
export default outPlantIntervalTimeNextSign



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/outPlantIntervalTimeNextSign/lang/index.en.js